<template>
  <div class="inner">
    <AdminLnb />
    <slot></slot>
  </div>
</template>

<script>

import AdminLnb from "@/components/AdminLnb"

export default {
  name: "adminLayout",
  components: {
    AdminLnb
    //test
  },
  created(){ console.log("@@@@@ adminLayout")}
};
</script>